import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { NotesProvider } from '@models/notes-provider.interface';
import { NoteDto } from '@models/note-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class JobNotesProvider implements NotesProvider {
  private readonly apiService = inject(ApiService);

  getNotes(jobId: number): Observable<NoteDto[]> {
    return this.apiService.get(`jobs/${jobId}/notes`);
  }

  addNote(jobId: number, text: string): Observable<unknown> {
    return this.apiService.post(`jobs/${jobId}/notes`, { text });
  }

  updateNote(jobId: number, noteId: number, text: string): Observable<unknown> {
    return this.apiService.put(`jobs/${jobId}/notes/${noteId}`, { text });
  }

  deleteNote(jobId: number, noteId: number): Observable<unknown> {
    return this.apiService.delete(`jobs/${jobId}/notes/${noteId}`);
  }
}
